// extracted by mini-css-extract-plugin
module.exports = {"baggageList__item":"baggageList__item-eYgaT","baggageList__price":"baggageList__price-1XzLR","baggageCount__root":"baggageCount__root-3GUvr"};